/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Candidate_Profile_Calendar_Dialog_TitleInputs */

const en_candidate_profile_calendar_dialog_title = /** @type {(inputs: Candidate_Profile_Calendar_Dialog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instructions to subscribe to a calendar via ICS.`)
};

const de_candidate_profile_calendar_dialog_title = /** @type {(inputs: Candidate_Profile_Calendar_Dialog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anleitung um einen Kalender per ICS zu abonnieren.`)
};

/**
* | output |
* | --- |
* | "Instructions to subscribe to a calendar via ICS." |
*
* @param {Candidate_Profile_Calendar_Dialog_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const candidate_profile_calendar_dialog_title = /** @type {((inputs?: Candidate_Profile_Calendar_Dialog_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Candidate_Profile_Calendar_Dialog_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_candidate_profile_calendar_dialog_title(inputs)
	return en_candidate_profile_calendar_dialog_title(inputs)
});